
import useI18n from "../../../hooks/useI18n";
import * as React from 'react';
import Box from '@mui/material/Box';
import TableData from '../../custom/Table/TableData';
import Typography from '@mui/material/Typography';

import orderService from "../../../api/order";
import useUserInfo from '../../../hooks/useUserInfo';
import CellType from '../../../constants/type';
import { useNavigate } from 'react-router-dom';
import Search from "../../custom/Search/Search";

import { ordersState } from '../../../state/ordersState';
import { useRecoilState } from "recoil";
import { currencySignPrice1 } from '../../../config';


export default function Orders() {
    const { lang, l } = useI18n();
    const [orders, setOrders] = useRecoilState(ordersState);
    const {user} = useUserInfo();
    const navigate = useNavigate();

    const [search, setSearch] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');
    
    // Пагінація
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(20);
    const [loading, setLoading] = React.useState(false);
    const [ownPagination, setOwnPagination] = React.useState({
        page: 1,
        pageSize: 20,
        totalItems: 0,
        totalPages: 0,
        rowsPerPageOptions: [10, 20, 50, 100],
    });

    const columns = [
        { id: 'OFFICIALSERNR', label: l('Number'), minWidth: 200, type: CellType.STRING, align: 'center' },
        { id: 'ORDDATE', label: l('Date'), minWidth: 200, type: CellType.DATEONLY, align: 'center' },
        { id: 'SUM4',label: `${l('Sum')}`, minWidth: 150, type: CellType.ORDERSUM, align: 'center' },
        { id: 'COMMENT2', label: l('Comment'), minWidth: 100, type: CellType.STRING, align: 'center' },
        { id: 'CUSTOMSTATUSFLAGTEXT', label: l('Status'), minWidth: 150, type: CellType.STRING, align: 'center' },
    ];


    const getOrdersList = async (currentPage = 1, currentPageSize = pageSize) => {
        setLoading(true);
        try {
            if (user) {
                const response = await orderService.findAllByUserId(user.CODE, lang, currentPage, currentPageSize);
                if(response) {
                    setOrders(response.orders);
                    setOwnPagination(prev => ({
                        ...prev,
                        page: response.page || currentPage,
                        pageSize: response.limit || currentPageSize,
                        totalItems: response.total || 0,
                        totalPages: response.totalPages || 0,
                    }));
                }
            }
            
        } catch (error) {
            console.error('Error getOrdersList :>> ', error);
        } finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        if (user) {
            getOrdersList(page, pageSize);
        }
    }, [user, page, pageSize]);

    function setClickRow(params) {
        navigate(`/order/${params.OFFICIALSERNR}`, { state: { recid: params.recid } });
    }

    const handelSearch = (value) => {

        if (value === '') {
            setSearchValue('');
            setSearch([]);
            return;
        }

        setSearchValue(value);

        setSearch(orders?.filter((item) =>
            item.ORDDATE?.toLowerCase().includes(value.toLowerCase())
            || item.OFFICIALSERNR?.toString().toLowerCase().includes(value.toLowerCase())
            || item.CUSTOMSTATUSFLAGTEXT?.toLowerCase().includes(value.toLowerCase())
        ));
    }

    function setTableRows() {

        if (search.length > 0) {
            return search;
        }
      
        return orders;
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        setSearch([]);
        setSearchValue('');
    };

    const handleChangeRowsPerPage = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPage(1);
        setSearch([]);
        setSearchValue('');
    };

    return (
        <>
            <Box display="flex" justifyContent="space-between" margin={'10px 0'} flexWrap={'wrap-reverse'}>
                <Typography component="h2" variant="h5">
                    {l('Orders history')}
                </Typography>
                <Search onChange={handelSearch} value={searchValue} />
            </Box>
            <TableData 
                isPointCursor={true} 
                setClickRow={setClickRow} 
                columns={columns} 
                rows={setTableRows()} 
                tableEmptyText={loading ? l('Loading...') : l('No data available')}
                ownPagination={ownPagination}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
                isShowBrand={false}
                isShowCategory={false}
                isGrouped={false}
            />
        </>
    );
    

}


